import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import AOAlert from './AOAlert';

const AOAlertExpandable = ({ initialOpen, message, ...props }) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  return (
    <AOAlert style={{ position: 'relative' }} message={isOpen ? message : undefined} {...props}>
      {message && (
        <IconButton
          color="inherit"
          size="small"
          onClick={() => setIsOpen(!isOpen)}
          style={{ position: 'absolute', top: '0.5rem', right: '0.5rem' }}>
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      )}
    </AOAlert>
  );
};

AOAlertExpandable.defaultProps = {
  initialOpen: false,
};

AOAlertExpandable.propTypes = {
  initialOpen: PropTypes.bool,
  message: PropTypes.string,
};

export default AOAlertExpandable;
